export default __webpack_public_path__ + "static/SupremeLL-JumboItalic-1fb35f7369ff8343839779b8338c36ed.woff2";